import type { LucideIcon } from 'lucide-react';
import {
  LayoutDashboard,
  Users2,
  Calendar,
  ClipboardCheck,
  CreditCard,
  TicketCheck,
  CalendarClock,
  Gift,
} from 'lucide-react';

export interface NavItem {
  path?: string;
  labelKey: string;
  icon: LucideIcon;
  items?: NavItem[];
}

export const navItems: NavItem[] = [
  { path: '/', labelKey: 'student.navigation.dashboard', icon: LayoutDashboard },
  { path: '/groups', labelKey: 'student.navigation.groups', icon: Users2 },
  { path: '/sessions', labelKey: 'student.navigation.sessions', icon: Calendar },
  { path: '/schedule', labelKey: 'student.navigation.schedule', icon: CalendarClock },
  { path: '/attendance', labelKey: 'student.navigation.attendance', icon: ClipboardCheck },
  { path: '/payments', labelKey: 'student.navigation.payments', icon: CreditCard },
  { path: '/referrals', labelKey: 'student.navigation.referrals', icon: Gift },
  { path: '/tickets', labelKey: 'student.navigation.tickets', icon: TicketCheck },
];
